import axios from "axios";
import { defineStore } from "pinia";
import { ref, watchEffect } from "vue";

export const useFinanceStore = defineStore("finance", {
  state: () => ({
    LoggedYear: ref(new Date().getFullYear()),
    apiUrl: process.env.VUE_APP_URL_API,
    student_id_enroll: null,
    statistics: {
      totalExtractNotPayed: 0,
      totalExtracto: 0,
      totalReferencesMonthNotPayed: 0,
      totalOtherReferencesPayed: 0,
      totalExtractoPayd: 0,
      totalgetReferencePanding: 0,
      totalotherReferencesNotPayed: 0,
      inscription_year: 0,
    },
    loading: false,
  }),

  actions: {
    async fetchStatistics() {
      try {
        this.loading = true;
        const profile = JSON.parse(localStorage.getItem("myProfile"));

        const endpoints = [
          `Extracto?student_id=${profile?.student_id_enroll}&LoggedYear=${this.LoggedYear}`,
          `ReferencesMonthNotPayed?student_id=${profile?.student_id_enroll}&LoggedYear=${this.LoggedYear}`,
          `OtherReferencesPayedTotal?student_id=${profile?.student_id_enroll}&LoggedYear=${this.LoggedYear}`,
          `ExtractoPayd?student_id=${profile?.student_id_enroll}&LoggedYear=${this.LoggedYear}`,
          `ReferencesFineTotal?student_id=${profile?.student_id_enroll}&LoggedYear=${this.LoggedYear}`,
          `otherReferencesNotPayedTotal?student_id=${profile?.student_id_enroll}&LoggedYear=${this.LoggedYear}`,
          `getInscriptionYear?student_id=${profile?.student_id_enroll}`,
        ];

        const responses = await Promise.all(
          endpoints.map((endpoint) => axios.get(this.apiUrl + endpoint))
        );

        const [
          Extracto,
          ReferencesMonthNotPayed,
          OtherReferencesPayed,
          ExtractoPayd,
          getReferencePanding,
          otherReferencesNotPayed,
          inscription_year,
        ] = responses.map((response) => response.data);

        // statistics.value.totalExtracto = Extracto.data;
        // statistics.value.totalReferencesMonthNotPayed = ReferencesMonthNotPayed;
        this.statistics.totalOtherReferencesPayed = OtherReferencesPayed;
        this.statistics.totalExtractoPayd = ExtractoPayd.total;
        this.statistics.totalgetReferencePanding = getReferencePanding;
        this.statistics.totalotherReferencesNotPayed = otherReferencesNotPayed;
        this.statistics.inscription_year = inscription_year;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    setTotalExtractNotPayed(value) {
      this.statistics.totalExtractNotPayed = value;
    },
  },

  persist: {
    enabled: true,
  },
});
